import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import './styles/custom.css';
import { PublicContextProvider } from './components/PublicContext';

export default function App() {
    const TrackPageView = () => {
        const location = useLocation();

        useEffect(() => {
            if (window.gtag) {
                window.gtag('config', 'G-YF1G85XFYS', {
                    page_path: location.pathname + location.search,
                });
            }
        }, [location]);

        return null;
    };

    return (
        <PublicContextProvider>
            <Layout>
                <TrackPageView />
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, requireAuth, ...rest } = route;
                        return (
                            <Route
                                key={index}
                                {...rest}
                                element={element}
                            />
                        );
                    })}
                </Routes>
            </Layout>
        </PublicContextProvider>
    );
}